// Tarjeta de la cola de Anexos activos.
//
// Patrón visual portado de src/components/RecepcionDigital/EncomiendaCard.jsx:
// tarjeta de triaje (nunca fila de tabla), nombre del cliente al frente, chip
// de estado arriba a la derecha, conteos + tiempo transcurrido abajo, una sola
// acción primaria.
//
// Diferencia deliberada con EncomiendaCard: aquí "Abrir" es un span decorativo,
// no un <button>. La tarjeta entera ya es el control (role="button") y su única
// acción es la misma que la del botón — anidar un botón dentro de un role=button
// es interactivo-dentro-de-interactivo y rompe la navegación por teclado.

import { timeAgoEs } from './format';

const last4 = (phone) => (phone || '').replace(/\D/g, '').slice(-4);

const AnexoQueueCard = ({ anexo, onOpen }) => {
  const abrir = () => onOpen(anexo.id);

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      abrir();
    }
  };

  const digits = last4(anexo.phone_number);
  const absolute = anexo.updated_at
    ? new Date(anexo.updated_at).toLocaleString('es-SV')
    : 'Sin fecha';

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={abrir}
      onKeyDown={onKeyDown}
      aria-label={`Abrir el Anexo de ${anexo.full_name || anexo.client_id}`}
      className="group flex flex-col bg-white border border-slate-200 rounded-2xl p-5 cursor-pointer transition-colors hover:border-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-900"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-base font-bold text-slate-900 truncate">
            {anexo.full_name || anexo.client_id}
          </p>
          <p className="mt-0.5 text-sm text-slate-500">
            {digits ? `•••• ${digits}` : 'Sin teléfono'}
          </p>
        </div>
        <span className="shrink-0 text-[10px] font-bold uppercase px-2 py-0.5 rounded border bg-green-50 text-green-700 border-green-200">
          Activo
        </span>
      </div>

      <p className="mt-4 text-xs text-slate-500">
        {anexo.intake_count} {anexo.intake_count === 1 ? 'captura' : 'capturas'}
        <span className="mx-1.5 text-slate-300">·</span>
        {anexo.item_count} {anexo.item_count === 1 ? 'artículo' : 'artículos'}
      </p>

      <p className="mt-1 text-[11px] text-slate-400" title={absolute}>
        Actualizado {timeAgoEs(anexo.updated_at)}
      </p>

      {/* Decorativo: la tarjeta entera es el control. */}
      <span
        aria-hidden="true"
        className="mt-4 h-11 flex items-center justify-center rounded-lg bg-slate-900 text-white text-sm font-semibold transition-opacity group-hover:opacity-90"
      >
        Abrir
      </span>
    </div>
  );
};

export default AnexoQueueCard;
